export enum UniqueCodeTypeOption {
  LexiId = 0,
  EAN = 1,
  WeighingGoods = 2,
  SupplierProductCode = 3,
  EanOrSupplierCode = 5
}

(UniqueCodeTypeOption as any).__typeName = 'UniqueCodeTypeOption';